import { createApi } from '@reduxjs/toolkit/query/react';

import { apiUsers } from '~constants/api';

import { Response, rtkBaseQueryWrapper, unwrap } from '~libs/axiosWrapper';

import { AccessTag } from './accessTags';

export const typePrefix = `user-tags`;

export interface UserTag {
  id: number;
  full_name: string;
  access_tags: AccessTag[];
}

type UserTagRequest = { user_id: number; tag_id?: string; tags?: string[] };

export const userTagsApi = createApi({
  reducerPath: 'userTagsApi',
  baseQuery: rtkBaseQueryWrapper({ baseUrl: apiUsers }),
  tagTypes: ['userTags'],
  endpoints: (builder) => ({
    getUserTags: builder.query<UserTag[], { module: string; name: string }>({
      query: ({ module, name }) => ({ url: '/tags', method: 'GET', params: { module, name } }),
      providesTags: [{ type: 'userTags', id: 'LIST' }],
      transformResponse: (payload) => unwrap<UserTag[]>(payload),
    }),
    createUserTag: builder.mutation<UserTag, UserTagRequest>({
      query: ({ user_id, tag_id }) => ({ url: '/tags', method: 'POST', body: { user_id, tag_id } }),
      invalidatesTags: [{ type: 'userTags', id: 'LIST' }],
      transformResponse: (payload) => unwrap<UserTag>(payload),
    }),
    deleteUserTag: builder.mutation<Response<UserTag[]>, UserTagRequest>({
      query: ({ user_id, tags }) => ({ url: '/tags', method: 'DELETE', body: { user_id, tags } }),
      invalidatesTags: [{ type: 'userTags', id: 'LIST' }],
      transformResponse: (payload) => payload as Response<UserTag[]>,
    }),
  }),
});

export const { useGetUserTagsQuery, useCreateUserTagMutation, useDeleteUserTagMutation } = userTagsApi;
